import React from "react";

import { PageTitleProps } from "@models/components/organisation.model";

const PageTitle: React.FC<PageTitleProps> = ({ title }) => (
  <h1 data-testid="pageTitle">{title}</h1>
);

export default PageTitle;
